import React, { useEffect, useContext } from 'react'
import { func } from 'prop-types'

import { EngravingContext } from 'components/buy/Engraving/EngravingContext'
import Heading from 'components/buy/Engraving/Heading'
import EngravingOption from 'components/buy/Engraving/EngravingOption'
import List from 'components/buy/Engraving/List'

const InitialStep = ({ setStep }) => {
  const { engraving, currentView, setCurrentView } = useContext(EngravingContext)
  const { front } = engraving

  useEffect(() => {
    setCurrentView({ ...currentView, item: 'front', step: 'initialstep' })
  }, [])

  return (
    <>
      <Heading number="01" title="Customize the Front" description="Select one design style to add to your ePod" />
      <List row={3}>
        {Object.keys(front).map((key, idx) => {
          if (typeof front[key] === 'object') {
            return (
              <EngravingOption
                key={idx}
                onClick={() => {
                  setStep(key)
                }}
                name={front[key].displayName}
                figure={front[key].slug}
                isLarge
              />
            )
          }
        })}
      </List>
    </>
  )
}

InitialStep.propTypes = {
  setStep: func.isRequired
}

export default InitialStep
